import { useCallback } from 'react';
import { useCurrentStateAndParams } from '@uirouter/react';

import { setPortainerAgentTargetHeader } from '@/portainer/services/http-request.helper';
import { useService } from '@/react/docker/services/queries/useService';
import { getServiceLogs } from '@/react/docker/services/queries/services.service';

import { PageHeader } from '@@/PageHeader';
import { LogViewer } from '@@/LogViewer';
import { GetLogsParamsInterface } from '@@/LogViewer/types';

export function LogView() {
  const {
    params: { endpointId: environmentId, id: serviceId, nodeName },
  } = useCurrentStateAndParams();

  const getLogsFn = useCallback(
    ({ since, tail, timestamps }: GetLogsParamsInterface) => {
      setPortainerAgentTargetHeader(nodeName);

      return getServiceLogs(environmentId, serviceId, {
        stdout: true,
        stderr: true,
        timestamps,
        tail: tail || 0,
        since,
      });
    },
    [environmentId, serviceId, nodeName]
  );

  const serviceQuery = useService(environmentId, serviceId);
  const serviceName = serviceQuery.data?.Spec?.Name || '';

  const breadcrumbs = [
    { label: 'Services', link: 'docker.services' },
    {
      label: serviceName,
      link: 'docker.services.service',
      linkParams: { id: serviceId },
    },
    'Logs',
  ];

  return (
    <>
      <PageHeader title="Service logs" breadcrumbs={breadcrumbs} reload />
      <LogViewer
        resourceType="docker-service"
        resourceName={serviceName}
        getLogsFn={getLogsFn}
      />
    </>
  );
}
